/** Image selection and editable/exportable mode must be separated.
 * An unsupported PDF bitmap may be PREVIEWED from the canvas but cannot
 * safely be MOVED or deleted: the crop can contain neighbouring artwork.
 */
export const FALLBACK_WARNING = 'Bu görsel PDF’den bağımsız çıkarılamadı. Önizlemeden seçildi; çevredeki içerik zarar görmesin diye bu nesneye yapılan değişiklikler PDF’ye kaydedilemez.';

export function chooseImagePickResult(rect, extractedBlob, screenshotBlob) {
  if (extractedBlob) return {blob:extractedBlob,selectionMode:'extracted',sourceRisk:rect.sourceRisk||null};
  if (screenshotBlob) return {blob:screenshotBlob,selectionMode:'preview',sourceRisk:rect.sourceRisk||FALLBACK_WARNING};
  // Even if screenshot canvas is unavailable, the user must be able to select
  // the rectangle and inspect its coordinates. It is not an extractable image.
  return {blob:null,selectionMode:'placeholder',sourceRisk:rect.sourceRisk||FALLBACK_WARNING};
}
